import { useState, useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useT } from "../contexts/LanguageContext";
import SEOHead from "../components/app/SEOHead";

export default function ResetPassword() {
  const { lang } = useT();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = params.get("token");
    if (t) setToken(t);
  }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error(lang === "tr" ? "Parola en az 8 karakter olmalı" : "Password must be 8+ chars");
      return;
    }
    if (password !== confirm) {
      toast.error(lang === "tr" ? "Parolalar eşleşmiyor" : "Passwords don't match");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/password-reset/confirm", { token, new_password: password });
      toast.success(lang === "tr" ? "Parolan güncellendi. Şimdi giriş yap." : "Password updated. Please log in.");
      setTimeout(() => navigate("/login"), 1200);
    } catch (err) {
      toast.error(err?.response?.data?.detail || (lang === "tr" ? "Bağlantı geçersiz veya süresi dolmuş" : "Invalid or expired link"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white grid lg:grid-cols-2">
      <SEOHead pageKey="login" />
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <Link to="/" className="flex items-center gap-2 mb-10">
            <img src="/logo-full.png" alt="PMCoach AI" className="h-12 w-auto" />
          </Link>
          <h1 className="font-display text-3xl font-bold" data-testid="reset-title">
            {lang === "tr" ? "Yeni parola belirle" : "Set a new password"}
          </h1>
          <p className="text-slate-500 mt-2 text-sm">
            {lang === "tr" ? "En az 8 karakter." : "At least 8 characters."}
          </p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="text-sm font-semibold">
                {lang === "tr" ? "Yeni parola" : "New password"}
              </label>
              <input
                type="password" required minLength={8}
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#002FA7]"
                data-testid="reset-password-input"
              />
            </div>
            <div>
              <label className="text-sm font-semibold">
                {lang === "tr" ? "Parolayı tekrarla" : "Confirm password"}
              </label>
              <input
                type="password" required minLength={8}
                value={confirm} onChange={(e) => setConfirm(e.target.value)}
                className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#002FA7]"
                data-testid="reset-confirm-input"
              />
            </div>
            <button
              disabled={loading || !token}
              className="w-full btn-primary disabled:opacity-50"
              data-testid="reset-submit-button"
            >
              {loading ? "..." : lang === "tr" ? "Parolayı güncelle" : "Update password"}
            </button>
          </form>
          <div className="mt-6 text-sm text-slate-500">
            <Link to="/login" className="text-[#002FA7] font-semibold hover:underline">
              ← {lang === "tr" ? "Girişe dön" : "Back to login"}
            </Link>
          </div>
        </div>
      </div>
      <div className="hidden lg:block bg-gradient-to-br from-[#002FA7] via-[#0F3FCF] to-[#5B47E0]" />
    </div>
  );
}
